import {AddIcon, ChevronRightIcon} from '@chakra-ui/icons';
import {
  Heading,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import CurrentWorldType from './CurrentWorldType';
import {getCoverContent} from './coverContent';
import {
  fontFamily,
  getWorldTypeAccentColor, worldTypes,
} from './config';
import PublicWorldsList from './PublicWorldsList';

const BrowseModal = ({
  isOpen,
  onClose,
  onNewWorldClick,
  onWorldClick,
  worldType,
  worlds,
}) => {
  const content = getCoverContent(worldType);
  const accentColor = getWorldTypeAccentColor({
    rules: {
      worldType,
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay
        background="none"
      />

      <ModalContent
        bg="black"
        borderRadius="none"
        borderColor={accentColor}
        borderWidth={4}
        fontFamily={fontFamily}
        h="96vh"
        w="48vw"
        // margin="0"
        marginTop="1em"
        marginBottom="0"
        p={4}
      >
        <Stack h="full" minH={0}>
          <Heading
            color={accentColor}
            fontFamily={fontFamily}
            size="md"
            textAlign="center"
            textTransform="uppercase"
            p={2}
          >
            {content.publicListLabel}
          </Heading>

          <PublicWorldsList
            onNewWorldClick={onNewWorldClick}
            onWorldClick={onWorldClick}
            worldType={worldType}
            worlds={worlds}
          />
        </Stack>
      </ModalContent>
    </Modal>
  );
};

export default BrowseModal;
